import React, { useEffect } from 'react';
import { DashboardLayout } from '../components/UI/Layout/DashboardLayout';
import { DashboardComponent } from '../components/Dashboard/DashboardComponent';

export const Dashboard: React.FC = () => {
    useEffect(() => {
        document.title = 'Dashboard - Organizations';
    }, []);

    return (
        <DashboardLayout>
            <DashboardComponent />
        </DashboardLayout>
    );
};

export default Dashboard;
